import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SelectivePreloadingStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<any>): Observable<any> {
    // Don't preload modules when the current URL contains 'lps'
    if (this.isOnLPSRoute()) {
      return of(null);
    }

    // Preload all other modules for better performance
    return load();
  }

  private isOnLPSRoute(): boolean {
    // Check if the current URL contains 'lps'
    if (typeof window !== 'undefined') {
      return window.location.pathname.includes('/lps/');
    }
    return false;
  }
}
